import { useAuthentication, useForgotPassword } from '@psyomics/ui-common';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageLayout } from '../../../layouts/page-layout/page-layout';
import { BackLink } from '../../../molecules/back-link/back-link';
import { ForgotPasswordForm } from '../forgot-password-form/forgot-password-form';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { apiUrl } = useAuthentication();
  const navigate = useNavigate();
  const forgotPassword = useForgotPassword(apiUrl);

  const handleSubmit = async ({ username }: { username: string }) => {
    try {
      await forgotPassword({ username });
      navigate('/forgot-password/confirm', { state: { username } });
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error(t('common.errors.networkError'));
    }
  };

  return (
    <PageLayout backLink={<BackLink text={t('common.buttons.goBack')} />} width="narrow">
      <ForgotPasswordForm onSubmit={handleSubmit} />
    </PageLayout>
  );
};

export { ForgotPassword };
